import React, { useEffect } from 'react'

import { ConfirmationModal, ModalActionTypes } from '@acorns/web-components'
import { useRemoteStrings } from '@acorns/web-utils'

import getDefaultEventData from 'components/Trackers/defaults'
import { PortfolioRiskLevel } from 'generated/types'
import trackEvent from 'utils/analytics/trackEvent'

import { CryptoInterstitalProps } from './CryptoInterstitial'
import { CryptoLanderContent } from './CryptoLanderContent'
import { BitcoinLanderViewed } from './events'

export const CryptoLander = (props: CryptoInterstitalProps) => {
  const { getRemoteString } = useRemoteStrings()

  const getAllocationPercent = () => {
    const riskLevel = props.recommendedRisk
    switch (riskLevel) {
      case PortfolioRiskLevel.Conservative:
        return '1'
      case PortfolioRiskLevel.ModeratelyConservative:
        return '2'
      case PortfolioRiskLevel.Moderate:
        return '3'
      case PortfolioRiskLevel.ModeratelyAggressive:
        return '4'
      case PortfolioRiskLevel.Aggressive:
        return '5'
    }
  }

  useEffect(() => {
    trackEvent('Screen Viewed', {
      eventData: BitcoinLanderViewed(props.investmentProduct),
      ...getDefaultEventData('Button Tapped'),
    })
  }, [])

  return (
    <>
      <CryptoLanderContent {...props} />
      <ConfirmationModal
        isOpen={props.isModalOpen}
        message={getRemoteString({
          key: 'invest.new_etf.lander.alert.add_to_portfolio.body.variable1',
          variables: [getAllocationPercent()],
        })}
        title={props['alert.add_to_portfolio.title']}
        onRequestClose={props.toggleModal}
        actions={[
          {
            label: props['alert.add_to_portfolio.cta.cancel'],
            type: ModalActionTypes.secondary,
            handler: props.toggleModal,
          },
          {
            label: props['alert.add_to_portfolio.cta.confirm'],
            type: ModalActionTypes.primary,
            handler: props.onAddPortfolioConfirmPress,
          },
        ]}
      />
    </>
  )
}
